/**
 * @copyright © Paramount Streaming
 * @author  Stan Gletski
 * @description Strings used by Logger (prevents duplication)
 */
export enum TagLoggerString {
	ON_TAG_EVENT = 'onTagEvent:',
	ON_PLAYER_EVENT = 'onPlayerEvent:',
	ON_FATAL_ERROR = 'onFatalError:',
	RESET_TAG = 'resetTag:',
	PLAYER_DESTROY_REQUEST_CALLBACK = 'playerDestroyRequestCallback:',
	INITIALIZE = 'initialize:',
	EXECUTE_PLAYER_CREATE_EVENT = 'executeCreatePlayerRequest:',
	SET_DAI_SSB_IU = 'set_DAI_SSB_IU'
}